import { z } from 'zod';
/** Abfrageparameter des Audit-Protokolls. */
export const auditQuerySchema = z.object({
    /** Teil des Aktionsnamens, z. B. `user.` für alle Benutzeraktionen. */
    action: z.string().trim().max(64).optional(),
    /** Benutzername des Ausführenden. */
    actor: z.string().trim().max(64).optional(),
    limit: z.coerce.number().int().min(1).max(200).default(50),
});
/** Eintrag des Audit-Protokolls. */
export const auditEntrySchema = z.object({
    id: z.number().int(),
    createdAt: z.string(),
    actor: z.string().nullable(),
    action: z.string(),
    entity: z.string().nullable(),
    entityId: z.number().int().nullable(),
    detail: z.record(z.string(), z.unknown()),
    ip: z.string().nullable(),
});
/** Antwort des Audit-Protokolls. */
export const auditListSchema = z.object({ entries: z.array(auditEntrySchema) });
//# sourceMappingURL=audit.js.map